// extracted by mini-css-extract-plugin
export default {"HoverAlmaTitles":"HoverAlmaTitles_HoverAlmaTitles__0xdBx"};